import { loadAnimation } from 'lottie-web/build/player/lottie_light';
import { gsap } from "gsap";

export default class LottieHandler{
    init(){
		gsap.utils.toArray('[data-lottie="globe"]').forEach( (e) => {
			const logo = loadAnimation({
				container: e,
				renderer: "svg",
				loop: true,
				autoplay: true,
				path: themeData.theme_uri + "/_dist/json/globe.json",
			});
		});
	}

}